// extracted by mini-css-extract-plugin
module.exports = {"root":"_2E5fj"};